import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const createApi = (base) => ({
  getDashboard: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetDashboard?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getInventory: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetInventory?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getMovementReport: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetMovementReport?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getOpenControlQueue: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetOpenControlQueue?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getStocktakes: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetStocktakes?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getStocktakeDetail: async (id) => {
    const response = await api.request({
      url: `${base}/GetStocktakeDetail?${queryString.stringify({ id })}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  startStocktake: async (data) => {
    const response = await api.request({
      url: `${base}/StartStocktake`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  saveStocktakeCounts: async (data) => {
    const response = await api.request({
      url: `${base}/SaveStocktakeCounts`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  completeStocktake: async (data) => {
    const response = await api.request({
      url: `${base}/CompleteStocktake`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  cancelStocktake: async (data) => {
    const response = await api.request({
      url: `${base}/CancelStocktake`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },
});

export const warehouseCheckingManagementApi = createApi("/SLN/Management/WarehouseChecking");
export const warehouseCheckingOperatorApi = createApi("/SLN/SolarentOperator/WarehouseChecking");
export default warehouseCheckingManagementApi;
